const { get, post, put, del } = require("network/http/api")

export const getUserBilling = () => {
  return get(`/billing/me`)
}
